import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import ButtonContainer from "../components/ButtonContainer";
import { useAppDispatch, useAppSelector } from "../hooks/redux-toolkit";
import { toggleModal } from "../store/reducer/modal";
import { MODAL_TYPE, NUMBER, SIZES } from "../misc/constants";
import CardComponent from "../components/CardComponent";
import { useLazyGetAnnouncementsQuery } from "../store/reducer/setting";
import Loader from "../components/Loader";
import { AnnouncementType } from "../ts/component.types";
import { checkBoolean } from "../misc/utils";
import { Actions } from "../misc/access.enum";

const Announcements = () => {
  const dispatch = useAppDispatch();
  const { permissions } = useAppSelector((state) => state.authorization);
  const [announcements, setAnnouncements] =
    useState<Array<AnnouncementType> | null>(null);
  const [totalRowsCount, setTotalRowsCount] = useState<number>(NUMBER.ZERO);
  const [getAnnouncements, { data: announcementStateDate }] =
    useLazyGetAnnouncementsQuery();

  const handleClick = () => {
    dispatch(
      toggleModal({
        open: true,
        submitText: "Save and Close",
        modalType: MODAL_TYPE.ADD_ANNOUNCEMENT,
      })
    );
  };

  const buttons = [
    {
      label: "Add New Announcement",
      color: "primary",
      onClick: handleClick,
      size: SIZES.SMALL,
      access: checkBoolean(permissions?.[Actions.AddAnnouncement]),
    },
  ];

  const mapDataToRows = (announcements: any) => {
    return announcements.map((announcement: any) => {
      return {
        label: announcement?.label,
        id: announcement?.id,
        isActive: !announcement?.is_deleted,
      };
    });
  };

  useEffect(() => {
    let announcements, count;

    announcements = announcementStateDate?.data?.announcements;
    count = announcements ? announcementStateDate.data.count : NUMBER.ZERO;
    const announcementsData = announcements ? mapDataToRows(announcements) : [];
    setAnnouncements(announcementsData);
    setTotalRowsCount(count);
  }, [announcementStateDate]); //eslint-disable-line

  useEffect(() => {
    (async () => {
      await getAnnouncements("");
    })();
  }, []); //eslint-disable-line

  const handleEdit = (announcement: AnnouncementType) => {
    dispatch(
      toggleModal({
        open: true,
        edit: true,
        submitText: "Save and Close",
        modalType: MODAL_TYPE.ADD_ANNOUNCEMENT,
        data: {
          modalValues: { ...announcement },
        },
      })
    );
  };

  return (
    <Box>
      <ButtonContainer
        buttons={buttons}
        hideRightSearchField={true}
        hideReportButtons={true}
      />
      {!announcements ? (
        <Loader />
      ) : (
        <Box>
          <Box className="flex items-center">
            Total Announcements :{" "}
            <Box className="font-bold ml-1">{totalRowsCount}</Box>
          </Box>
          <Box className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 my-4">
            {announcements?.map((announcement) => {
              return (
                <CardComponent
                  title={announcement?.label}
                  subtitle={announcement?.id}
                  isActive={announcement?.isActive}
                  showStatus={true}
                  showEditIcon={checkBoolean(
                    permissions?.[Actions.UpdateAnnouncement]
                  )}
                  editClickListener={() => handleEdit(announcement)}
                  subtitleClassName="text-6xl mt-3"
                />
              );
            })}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Announcements;
